import React from "react";
import { Helmet } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import "./Disclaimer.css";

const IconClock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);

const SECTIONS = [
  { id: "general", label: "General" },
  { id: "external-links", label: "External Links" },
  { id: "testimonials", label: "Testimonials" },
  { id: "errors", label: "Errors & Omissions" },
  { id: "guest-contributors", label: "Guest Contributors" },
  { id: "trademarks", label: "Logos & Trademarks" },
  { id: "contact", label: "Contact Us" },
];

const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>Acadebility - Disclaimer</title>
        <meta name="description" content="Disclaimer" />
      </Helmet>

      <div className="lgl-page">
        {/* ── Hero ── */}
        <div className="lgl-hero">
          <div className="lgl-hero-inner">
            <nav className="lgl-breadcrumb">
              <Link to="/">Home</Link>
              <span className="lgl-sep">/</span>
              <span className="lgl-crumb-current">Disclaimer</span>
            </nav>
            <h1 className="lgl-title">Disclaimer</h1>
            <p className="lgl-subtitle">
              Important information about how the content on Acadebility should be used.
            </p>
            <span className="lgl-updated-badge"><IconClock /> Last updated: 2022-11-10</span>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="lgl-body">
          <div className="lgl-body-inner">

            <nav className="lgl-jumpnav" aria-label="Jump to section">
              {SECTIONS.map(s => (
                <a key={s.id} href={`#${s.id}`} className="lgl-jump-chip">{s.label}</a>
              ))}
            </nav>

            <div className="lgl-layout">

              <main className="lgl-content">

                <section id="general">
                  <h2>General Disclaimer</h2>
                  <p className="lgl-lead">
                    The information provided by Acadebility ("Company", "we", "our", "us") on acadebility.com is for general informational purposes only. While provided in good faith, we make no representation or warranty of any kind regarding its accuracy, adequacy, validity, reliability, or completeness.
                  </p>
                  <div className="lgl-callout">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                    <p>Under no circumstance shall we have any liability for any loss or damage incurred as a result of the use of the site. Your use of the site is solely at your own risk.</p>
                  </div>
                </section>

                <section id="external-links">
                  <h2>External Links Disclaimer</h2>
                  <p>
                    The site may contain links to third-party websites. We do not monitor or check these for accuracy or reliability, and are not responsible for their content.
                  </p>
                </section>

                <section id="testimonials">
                  <h2>Testimonials Disclaimer</h2>
                  <p>
                    Testimonials are from real users, but individual results may vary. They do not represent guaranteed outcomes.
                  </p>
                </section>

                <section id="errors">
                  <h2>Errors and Omissions Disclaimer</h2>
                  <p>
                    While we try to ensure accuracy, Acadebility is not responsible for errors or omissions in the content presented on the site.
                  </p>
                </section>

                <section id="guest-contributors">
                  <h2>Guest Contributors Disclaimer</h2>
                  <p>
                    Content from guest contributors reflects their personal opinions, not those of Acadebility.
                  </p>
                </section>

                <section id="trademarks">
                  <h2>Logos and Trademarks Disclaimer</h2>
                  <p>
                    Third-party trademarks and logos are the property of their respective owners and do not imply endorsement of Acadebility.
                  </p>
                </section>

                <section id="contact">
                  <h2>Contact Us</h2>
                  <p>If you have questions, contact us at <a href="mailto:acadebility@gmail.com">acadebility@gmail.com</a>.</p>
                </section>

              </main>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;